import {
    inject,
    observer
} from 'mobx-react'
import {
    WeaTableNew
} from 'comsMobx'
const WeaTable = WeaTableNew.WeaTable;

@inject('hrmTimeWageSummary') //todo
@observer
export default class Table extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this.props.hrmTimeWageSummary.resetTable();
    }

    render() {
        const {
            hrmTimeWageSummary,
        } = this.props, {
            table,
        } = hrmTimeWageSummary, {
            tableStore,
            colNum,
        } = table;

        return (
            <WeaTable 
                comsWeaTableStore={tableStore}
                hasOrder={true}
                needScroll={true}
                scroll={{x: colNum*100}}
            />
        )

    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/timeWageSummary/Table.js